import { ChangeEvent, ReactNode, useRef, useState } from "react";
import { InputNew, InputNewStyle } from "../InputNew/InputNew";
import "./InputNewImage.css";

interface InputNewImageProps extends React.InputHTMLAttributes<HTMLInputElement> {
    labelOutside?: string | ReactNode;
    error?: string;
    color?: InputNewStyle;
}


export const InputNewImage = ({ ...props }: InputNewImageProps) => {
    const ref = useRef<HTMLInputElement>(null);
    const [messageError, setMessageError] = useState<string>("");
    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        console.log("handleChange");
        if (event.target.files) {
            const error = validationSize(event.target.files[0]);
            if (error) {
                setMessageError(error);
                return;
            }
            setMessageError("");
            if (props.onChange) {
                props.onChange(event);
            }
        }
    };
    const validationSize = (file: File): string | null => {
        if (file.size > 1024 * 1024 * 5) {
            return "Файл не должен превышать 5MB";
        }
        return null;
    }

    return (
        <InputNew
            labelOutside={props.labelOutside}
            placeholder="Прикрепить фото"
            color={'inverse'}
            type="file"
            value={props.value}
            error={messageError}
            accept="image/*"
            ref={ref}
            onChange={handleChange}
        />
    )
}